import { useMutation, useQueryClient } from '@tanstack/react-query';

import { termsAndPrivacyKeys } from '@/api/rest/termsAndPrivacy/useGetTermsAndPrivacyUpdates';
import { apiFetch } from '@/utils/apiFetch';

const useAgreeToTermsAndPrivacyVersion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (version: number) => {
      const response = await apiFetch(
        `/api/users/terms_and_privacy_updates/${version}`,
        { method: 'POST', body: JSON.stringify({}) }
      );

      if (!response.ok) {
        throw new Error('Failed to agree to terms and privacy version');
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: termsAndPrivacyKeys.updates,
      });
    },
  });
};

export default useAgreeToTermsAndPrivacyVersion;
